/**
 * 西班牙语（es）
 */
export default {
  BatchSearch: {
    SearchingForOrderId: 'buscando la identificación del pedido',
    Select: 'Seleccionar'
  },
  BatchSearchOne: {
    SearchingForID: 'Buscando identificación'
  },
  IssuedDetailsDialog: {
    BillingInformation: 'Información de facturación',
    BillID: 'ID de factura',
    AwaitingPayment: 'En espera de pago',
    PaymentAmount: 'Monto del pago',
    BillsAmount: 'Monto de las facturas',
    PaidAmount: 'Monto de pago',
    OrderID: 'Solicitar ID',
    ParcelCode: 'Código de paquete',
    TableColumnPaidAmount: 'Monto de pago',
    DeliveryTime: 'El tiempo de entrega',
    PaymentDate: 'Fecha De Pago',
    Status: 'Estado',
    Shippped: 'Enviado'
  },
  PaymentDialog: {
    PayNow: 'Pagar ahora',
    PaymentAmount: 'Monto del pago',
    PleaseSelectYourPaymentMethod: 'Por favor seleccione su método de pago',
    Paypal: 'PayPal',
    CreditCard: 'Tarjeta de crédito',
    Balance: 'Balance',
    Others: 'Otros',
    ButtonPayNow: 'Pagar ahora'
  },
  Billing: {
    BillingStatement: 'Estado De Cuenta',
    Bills: 'Facturas',
    IncomingBills: 'Facturas Entrantes',
    Issued: {
      Status: 'Estado',
      WaitingPayment: 'Waiting Payment',
      PaymentProcessing: 'Esperando El Pago',
      Paid: 'Pagado',
      StartDate: 'Fecha De Inicio',
      EndDate: 'Fecha Final',
      Selected: 'Seleccionado',
      PayNow: 'Pagar Ahora',
      ID: 'ID',
      BillsAmount: 'Monto de las facturas',
      PaymentAmount: 'Monto del pago',
      TableColumnStatus: 'Estado',
      PaymentDate: 'Fecha De Pago',
      CreateDate: 'Fecha de Creación',
      ViewDetails: 'Ver Detalles',
      TableColumnPayNow: 'Pagar Ahora',
      NoRecord: 'No Recuerdo',
      Action: 'Acción'
    },
    Unpublished: {
      ParcelStatus: 'Estado del paquete',
      shipped: 'Enviado',
      completed: 'Terminado',
      Select: 'Seleccionar',
      PaymentTime: 'Tiempo De Pago',
      DeliveryTime: 'El Tiempo De Entrega',
      StatementDate: 'Fecha De Declaración',
      StartDate: 'Fecha De Inicio',
      EndDate: 'Fecha Final',
      OrderID: 'Solicitar ID',
      ParcelCode: 'Código De Paquete',
      Bills: 'Facturas',
      TableColumnParcelStatus: 'Estado Del Paquete',
      TableColumnPaymentTime: 'Tiempo De Pago',
      TableColumnDeliveryTime: 'El Tiempo De Entrega',
      TableColumnStatementDate: 'Fecha De Declaración',
      NoRecord: 'No Recuerdo',
      SearchOptinsOrderID: 'Solicitar ID',
      SearchOptinsParcelCode: 'Código De Paquete',
      PackStatusPreparing: 'preparando',
      PackStatusCancelled: 'cancelado',
      PackStatusShipped: 'enviado',
      PackStatusCompleted: 'terminado'
    }
  }
}
